import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { ConnectionService } from 'src/app/services/connection.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-care-kyc',
  templateUrl: './care-kyc.component.html',
  styleUrls: ['./care-kyc.component.scss'],
})
export class CareKycComponent implements OnInit {

  careKycForm: FormGroup;
  kycStatusMessage: string = "You're a ckyc complaint user. Now redirecting to proposal form!";
  showkycSuccessMessage: boolean = false;
  showkycFailureMessage: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private apiService: ConnectionService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private toast: ToastService,
    private loader: LoaderService
  ) { }

  ngOnInit() {
    this.careKycForm = this.fb.group({
      pan: ["", [Validators.required, Validators.pattern("^([a-zA-Z]){3}([cptfhCPTFH]){1}([a-zA-Z]){1}([0-9]){4}([a-zA-Z]){1}?$")]],
      dob: ["", [Validators.required, this.isMinor]]
    })
  }

  proceed() {
    let data = {
      panNumber: (this.careKycForm.get("pan").value).toUpperCase(),
      dob: this.datePipe.transform(this.careKycForm.get("dob").value, "yyyy-MM-dd")
    }
    console.log("data", data);
    this.loader.showLoader("Validating with server");
    this.apiService.checkCareKYC(data).subscribe(res => {
      this.loader.hideLoader();
      console.log("care kyc check api res", res);
      let cKycNo = res.data?.ckycDownloadResponse?.getCkycEkycInputIO?.kycDetails?.personalIdentifiableData?.personalDetails?.ckycNo;
      // let ekycReturnURL = res.data?.ekycReturnUrlResponse?.getEdharDetailsIO?.url;
      if (cKycNo) {
        this.showkycSuccessMessage = true;
        this.kycStatusMessage = "You're a ckyc complaint user. Now redirecting to proposal form!";
        setTimeout(() => {
          this.modalCtrl.dismiss({
            dataSelected: res.data?.ckycDownloadResponse?.getCkycEkycInputIO?.kycDetails?.personalIdentifiableData,
            goForward: true,
          });
        }, 3000);
      }
      // else if(ekycReturnURL){
      //   this.showkycSuccessMessage = true;
      //   this.kycStatusMessage = "You will be redirected to eAadhaar portal to check your ekyc status. Once completed you will be redirected back to policy proposal form."
      //   setTimeout(() => {
      //     this.modalCtrl.dismiss({
      //       dataSelected: res.data?.ekycReturnUrlResponse?.getEdharDetailsIO,
      //       goForward: true,
      //     })
      //   }, 10000)
      // }
      else {
        this.showkycFailureMessage = true;
        this.kycStatusMessage = "You're a ckyc Non-complaint user. Now redirecting to proposal form!"
        setTimeout(() => {
          this.modalCtrl.dismiss({
            // dataSelected: res.data?.ckycDownloadResponse?.getCkycEkycInputIO?.kycDetails?.personalIdentifiableData,
            goForward: true,
          });
        }, 3000);
      }
    }, err => {
      this.loader.hideLoader();
      console.log("care kyc check api error", err);
      if (err) {
        let errorMsg = JSON.parse(err.error.message)
        if (errorMsg.getCkycEkycInputIO) {
          console.log("sdsdfsdfsdf");
          if (errorMsg.getCkycEkycInputIO.errorLists[0].errDescription.includes("Date of birth entered does not match with the date of birth stated in the CKYC")) {
            console.log("sdsdfsdfsdf 121212");
            this.showkycFailureMessage = true;
            this.kycStatusMessage = "DOB entered does not match!. Please enter the correct DOB."
          }
        }

        if (errorMsg.getEdharDetailsIO) {
          if (errorMsg.getEdharDetailsIO.errorLists[0].errDescription.includes("Error coming from Aadhar Details API Request limit exceeded")) {
            setTimeout(() => {
              this.modalCtrl.dismiss({
                // dataSelected: res.data?.ckycDownloadResponse?.getCkycEkycInputIO?.kycDetails?.personalIdentifiableData,
                goForward: true,
              });
            }, 3000);
          }
        }
      }
    })
  }

  close() {
    this.modalCtrl.dismiss({
      dataSelected: "dataforcarekyc",
      goForward: false,
    });
  }

  isMinor(control: AbstractControl) {
    const dob: string = control.value;
    const today = new Date();
    let dobInput = new Date(dob);
    let age = today.getFullYear() - dobInput.getFullYear();
    let mnth = today.getMonth() - dobInput.getMonth();
    if (mnth < 0 || (mnth === 0 && today.getDate() < dobInput.getDate())) {
      age--;
    }
    if (age < 18) {
      return { 'dobError': true };
    } else {
      return null;
    }
  }

}
